<template>
<modal name="createGradeModal" transition="pop-out" :width="modalWidth" :height="300">
  <div class="modal__header">
      <h4>Add New Grade</h4>
  </div>
  <div class="cas_input">
      <div class="row__wrapper">
          <div class="row">
            <div class="col-md-12">
                <div class="" style="width: 100%">
                    <span>Grade Name</span>
                    <div class="">
                        <input type="text" placeholder="Enter the Grade name" class="ml-3" v-model="gradeName"  />
                    </div>
                </div>
            </div>
        </div>
      </div>
      
      <div class="text-center mt-4">
        <button class="creaet_branch_btn"
            @click="validateDetails($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
            isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' }
            ]">
            Add Grade  <i class="fa fa-save ml-2"></i>
            <span class="">
                <img src="@/assets/img/git_loader.gif" v-if="showLoader"  width="25px"/>
            </span>
        </button>
      </div>
  </div>
</modal>
</template>
<script>
const MODAL_WIDTH = 450;
import configObject from "@/config";

export default {
  name: 'createGradeModal',
  data () {
    return {
      modalWidth: MODAL_WIDTH,
      unitName: null,
      objective: null,
      isButtonDisabled:  false,
      showLoader: false,
      branch: this.$store.getters.getBranchdetail,
      gradeName: null
    }
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH

  },
  methods: {
      validateDetails($event) {
        $event.preventDefault();
        if(!this.gradeName){
            this.$toasted.show("Fill in the missing Fields", {
                    theme: "bubble",
                    position: "top-center",
                    duration: 2000
                });
        }else {
            this.addGrade();
        }
    },
    closeModal(){
        this.$modal.hide('createGradeModal');
    },
    addGrade() {
        let dataToSend = {
            gradeName: this.gradeName,
        };
        this.showLoader = true;
        this.isButtonDisabled = true;
        this.axios.post(`${configObject.apiBaseUrl}/Grades/Add`, dataToSend, configObject.authConfig)
            .then(() => {
                this.showLoader = false;
                this.isButtonDisabled = false;
                this.closeModal();
                this.$eventHub.$emit("refreshGradesTable");
                this.$toast.success("Grade added successfully");
                this.gradeName = null;
                })
                .catch((error) => {
                    this.isButtonDisabled = false;
                    this.showLoader = false;
                    this.$toast.open({
                        message: "unable to add grade",
                        type: "error",
                        duration: 3000
                    });
                    console.log(error);
            });
    },
  }
}
</script>
